export const environment = {
  production: true,
  appVersion: 'v0.1',
   apiUri: 'https://callb.ai/api',
  apiUrl: 'api',
  socketUri: 'https://callb.ai/api',
  appThemeName: 'xoVOICE',
};

